export type Payload = {
    drill_id: any;
    y_drill_id: string;
    drill_level: string;
    y_drill_level: string;
    name: string;
};

export type PrevLevel = {
    drill_id: Array<any>;
    drill_level: string;
    y_drill_level: string;
    y_drill_id: string;
    name: string;
};

export type listMap = {
    categoryMap: { [key: number]: string };
    skillMap: { [key: number]: string };
};

export type Category = {
    tagId: number;
    tagName: string;
    skills?: skillList[];
};

export type skillList = {
    tagId: number;
    tagName: string;
    hasModule?: boolean;
};

export type ComponentPayloadMap = {
    user_trend: Payload;
    stream_analytics: Payload;
    question_analytics: Payload;
    skill_heat_map: Payload;
};

export type FilterList = {
    country: Array<string>;
    roleCombination: Array<any>;
    allRoleSelected: boolean;
    allCountriesSelected: boolean;
};

export type FilterMap = { [index: string]: any };
export enum FilterType {
    COUNTRY = 'country',
    ROLE_COMBINATION = 'roleCombination',
    API_ROLE = 'allRolesSelected',
    API_COUNTRY = 'allCountriesSelected'
}
export class StatWidgetInfo {
    type: string;
    tabType: string;
    title: string;
    icon: string;
    count: number;
    totalCount: number;
    link: string;
    data: any;
    graphType: string;
    bgColor: string;
    textColor: string;
    path: string;
    dataAvailable: boolean;
}
export class StatGraphData {
    xname: string;
    yname: string;
    availableDrillDowns: string;
    availableDrillUps: string;
    currentlyStreaming: number;
    data: { [key: number]: Array<number> };
    effectiveDate: string;
}

export type StatsInfoMap = {
    activated: StatWidgetInfo;
    auTrend: StatWidgetInfo;
    stream: StatWidgetInfo;
    question: StatWidgetInfo;
};

export class SearchConditions {
    filters: FilterMap;

    constructor() {
        this.filters = {
            country: [],
            roleCombination: [],
            allRolesSelected: false,
            allCountriesSelected: false
        };
    }
}
